module.exports = __webpack_public_path__ + "img/流体力学4_6_3.c9a0fbb0.jpg";